import type { ReactNode } from 'react';
import { Heading, Stack, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';

const wrapperStyles = css`
  background: ${vars.colors.panel.background};
  color: ${vars.colors.panel.foreground};
  padding: 40px 20px;
`;

interface HeaderProps {
  children?: ReactNode;
  className?: string;
  'data-testid': string;
  subtitle: string;
  title: string;
}

const Header = ({
  children,
  className,
  'data-testid': dataTestId,
  subtitle,
  title,
}: HeaderProps) => (
  <div className={cx(wrapperStyles, className)} data-testid={dataTestId}>
    <Stack align="center" spacing={8}>
      {title && <Heading level={1}>{title}</Heading>}
      {subtitle && (
        <Heading as="span" level={4}>
          {subtitle}
        </Heading>
      )}
    </Stack>
    {children}
  </div>
);

export default Header;
